import PendoButton from '../../components/button/pendo-button.vue.js';
import PendoClipboard from '../../directives/clipboard/pendo-clipboard.js';
import get from 'lodash/get.js';
import hljs from 'highlight.js/lib/core';
import javascript from 'highlight.js/lib/languages/javascript';
import plaintext from 'highlight.js/lib/languages/plaintext';

hljs.registerLanguage('javascript', javascript);
hljs.registerLanguage('plaintext', plaintext);
var script = {
  name: 'PendoCopyCodeBlock',
  components: {
    PendoButton
  },
  directives: {
    PendoClipboard
  },
  props: {
    codeToCopy: {
      type: String,
      required: true
    },
    language: {
      type: String,
      default: 'plaintext'
    },
    descriptionOptions: {
      type: Object,
      default: () => ({
        description: '',
        position: 'top'
      })
    },
    buttonOptions: {
      type: Object,
      default: () => ({
        label: 'Copy',
        position: 'top'
      })
    },
    snippetConfig: {
      type: Object,
      default: () => ({
        title: null,
        link: {
          icon: null,
          text: null
        }
      })
    },
    helpArticleUrl: {
      type: String,
      default: 'https://support.pendo.io/hc/en-us/articles/360039616892'
    }
  },
  computed: {
    buttonLabel() {
      return get(this.buttonOptions, 'label', '');
    },
    description() {
      return get(this.descriptionOptions, 'description', '');
    },
    isTopButton() {
      return get(this, 'buttonOptions.position') === 'top';
    },
    isRightButton() {
      return get(this, 'buttonOptions.position') === 'right';
    },
    isLeftDescription() {
      return get(this, 'descriptionOptions.position') === 'left';
    },
    isTopDescription() {
      return get(this, 'descriptionOptions.position') === 'top';
    },
    highlightedCode() {
      const result = hljs.highlight(this.codeToCopy, {
        language: this.language,
        ignoreIllegals: true
      });
      return result.value;
    }
  },
  methods: {
    openJwtHelpArticle() {
      window.open(this.helpArticleUrl, '_blank');
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-copy-code-block.vue2.js.map
